"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiConfig = void 0;
exports.ApiConfig = {
    apiKey: {
        name: 'apiKey',
        defaultValue: null,
    },
};
